var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: ["custom-field-label-pane__editor", _vm.field.field_type] },
    [
      _c(
        "ElPopover",
        {
          ref: "EditorPopover",
          attrs: {
            trigger: "manual",
            placement: _vm.controller.customCustomFieldEditorComponent
              ? "bottom-end"
              : "bottom-start",
            width: _vm.controller.customCustomFieldEditorComponent
              ? "auto"
              : 268,
            "visible-arrow": false,
            "popper-class":
              "pt-ui-popover custom-field-label-pane__layer-field-pane__popover",
          },
          model: {
            value: _vm.isPopoverVisible,
            callback: function ($$v) {
              _vm.isPopoverVisible = $$v
            },
            expression: "isPopoverVisible",
          },
        },
        [
          _c(
            "div",
            {
              ref: "inputContainer",
              staticClass: "custom-field-label-pane__editor__input-container",
              attrs: { slot: "reference" },
              on: {
                mouseup: function ($event) {
                  $event.stopPropagation()
                },
                click: _vm.focus,
              },
              slot: "reference",
            },
            [
              _vm._l(_vm.formattedValue, function (node) {
                return _c(
                  "div",
                  {
                    key: node.id,
                    staticClass: "custom-field-label-pane__option-item",
                  },
                  [
                    _c("span", [_vm._v(_vm._s(node.label))]),
                    _c("PtIcon", {
                      attrs: { icon: "SolidCloseMedium" },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.removeNode(node.id)
                        },
                      },
                    }),
                  ],
                  1
                )
              }),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.filter,
                    expression: "filter",
                  },
                ],
                ref: "inputRef",
                attrs: {
                  type: "text",
                  placeholder:
                    _vm.formattedValue && _vm.formattedValue.length
                      ? ""
                      : _vm.$t(
                          "PtCustomFieldLabelPane.editor.placeholder." +
                            _vm.field.field_type
                        ),
                },
                domProps: { value: _vm.filter },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.filter = $event.target.value
                  },
                },
              }),
            ],
            2
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "clickoutside",
                  rawName: "v-clickoutside",
                  value: _vm.onFinishEdit,
                  expression: "onFinishEdit",
                },
              ],
              on: { click: _vm.focus },
            },
            [
              _vm.field.show_ai
                ? _c(
                    "div",
                    { staticClass: "custom-field-label-pane__ai-check-tip" },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("PtCustomFieldLabelPane.readAsCheck")) +
                          " "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm.controller.customCustomFieldEditorComponent
                ? [
                    _vm.customCustomFieldEditorService.isShow
                      ? _c(_vm.controller.customCustomFieldEditorComponent, {
                          tag: "component",
                          attrs: {
                            service: _vm.customCustomFieldEditorService,
                          },
                        })
                      : _vm._e(),
                  ]
                : _c("OptionFieldPane", {
                    attrs: { field: _vm.field, filter: _vm.filter },
                    on: { change: _vm.onCheckChange },
                    model: {
                      value: _vm.value$,
                      callback: function ($$v) {
                        _vm.value$ = $$v
                      },
                      expression: "value$",
                    },
                  }),
            ],
            2
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }